import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
// import i18n from "i18next";
import { disablePollModeration, enablePollModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected } from './slice';
/**
 * Registers a change handler for state['features/base/conference'].conference to
 * set the event listeners needed for the poll moderation feature to operate.
 */
StateListenerRegistry.register((state) => state['features/base/conference'].conference, (conference, { dispatch }, previousConference) => {
    if (conference && !previousConference) {
        // local participant is allowed to unmute
        conference.on(JitsiConferenceEvents.POLL_MODERATION_APPROVED, ({ requestOccupantJid }) => {
            dispatch(localParticipantApproved());
            // if (requestOccupantJid) {
            //     dispatch(showNotification({
            //         uid: 'ALLOW_TO_CHAT',
            //         titleKey: i18n.t('notify.allowToChat')
            //     }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
            // }
        });
        conference.on(JitsiConferenceEvents.POLL_MODERATION_REJECTED, () => {
            dispatch(localParticipantRejected());
        });
        conference.on(JitsiConferenceEvents.POLL_MODERATION_CHANGED, ({ enabled, actor }) => {
            enabled ? dispatch(enablePollModeration(actor)) : dispatch(disablePollModeration(actor));
        });
        // this is received by moderators
        conference.on(JitsiConferenceEvents.POLL_MODERATION_PARTICIPANT_APPROVED, ({ participant }) => {
            const { _id: jid } = participant;
            // store in the whitelist
            dispatch(participantApproved({ jid }));
            // batch(() => {
            //     // remove from pending list
            //     // dispatch(dismissPendingParticipant(id));
            // });
        });
        // this is received by moderators
        conference.on(JitsiConferenceEvents.POLL_MODERATION_PARTICIPANT_REJECTED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantRejected({ jid }));
        });
    }
});
